
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Freiburg in der zweiten Welle`}</h2>
    <p>{`Die Frage, warum die Romandie stärker betroffen ist als die Deutschschweiz, beschäftigt die Öffentlichkeit intensiv. Als Erklärung ziehen Experten vor allem kulturelle Gründe heran (lesen Sie dazu auch den Artikel: `}<a parentName="p" {...{
        "href": "https://www.tagesanzeiger.ch/warum-hat-die-westschweiz-so-viele-infektionen-948291745145"
      }}>{`«Warum hat die Westschweiz so viele Infektionen?»`}</a>{`). Keine Rolle spielt hingegen das Mobilitätsverhalten, das sich zwischen den Landesteilen kaum unterscheidet. Die Mobilität gilt als verlässlicher Indikator dafür, wie sich die Fallzahlen in Zukunft entwickeln werden.`}</p>
    <p>{`Exemplarisch zeigen sich die Diskrepanzen am Kanton Freiburg: Die frankofonen Gemeinden auf der westlichen Seite des Röstigrabens sind fast durchwegs stärker betroffen als die benachbarten deutschsprachigen Gemeinden.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;